var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"homepage-v-card"},[_c('v-card-text',{staticClass:"glass-element"},[_c('NotificationList',{attrs:{"notifications":_vm.notifications}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }